import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { ProMessagingService } from '../pro-messaging.service';
import { Subject, Subscription } from 'rxjs';
import { ProMessagesDatasource } from './pro-messages.datasource';
import { CdkScrollable, CdkVirtualScrollViewport, FixedSizeVirtualScrollStrategy, ScrollDispatcher, VIRTUAL_SCROLL_STRATEGY, CdkVirtualForOf } from '@angular/cdk/scrolling';
import { MessageModel } from '../../api/models/message-model';
import { NgIf, AsyncPipe } from '@angular/common';
import { MatProgressBar } from '@angular/material/progress-bar';
import { ProOneMessageV2Component } from '../message/pro-one-message-v2.component';

export class CustomVirtualScrollStrategy extends FixedSizeVirtualScrollStrategy {
  constructor() {
    // super(500, 600, new ItemSizeAverager(146));
    super(146, 500, 600);
  }
}

@Component({
    selector: 'app-pro-messages-grid-v2',
    template: `
    <mat-progress-bar
      class="mat-progress-bar"
      mode="indeterminate"
      color="primary"
      *ngIf="messagesDatasource.loading$ | async"
    ></mat-progress-bar>

    <cdk-virtual-scroll-viewport cdkScrollable class="messages-viewport">
      <div *cdkVirtualFor="let item of messagesDatasource; let index = index">
        <app-pro-one-message-v2
          *ngIf="!!item"
          [model]="item"
          [searchText]="searchText"
          class="item-{{ index }}"
        ></app-pro-one-message-v2>
        <div *ngIf="!item" class="loading-item">
          <div>Loading...</div>
        </div>
      </div>
    </cdk-virtual-scroll-viewport>
  `,
    styles: [
        '.messages-viewport {height: 100%; overflow: auto;}',
        '.loading-item {height: 146px; text-align: center} .loading-item div {padding-top: 70px}',
        '.mat-progress-bar {width: 100%; position: absolute; left: 0; top: 0}',
    ],
    providers: [{ provide: VIRTUAL_SCROLL_STRATEGY, useClass: CustomVirtualScrollStrategy }],
    standalone: true,
    imports: [
        NgIf,
        MatProgressBar,
        CdkVirtualScrollViewport,
        CdkScrollable,
        CdkVirtualForOf,
        ProOneMessageV2Component,
        AsyncPipe,
    ],
})
export class ProMessagesGridV2Component implements OnInit, OnDestroy, OnChanges, AfterViewInit {
  private readonly TAG = '[ProMessagesGridV2Component]';
  @Input() selectedPhoneNumber: string;
  @Input() selectedThreadKey: string;
  @Input() searchText: string;
  @Output() lastIncomingMessageEvent = new EventEmitter<MessageModel>();

  @ViewChild(CdkScrollable) scrollContainer: CdkScrollable;
  @ViewChild(CdkVirtualScrollViewport) virtualScroll: CdkVirtualScrollViewport;

  private shouldInitScroll = true;
  private fetchPageSubscription: Subscription;
  private lastIncomingMessageSubscription: Subscription;
  private deBouncer: Subject<SimpleChanges> = new Subject<SimpleChanges>();

  constructor(
    public messagingService: ProMessagingService,
    public messagesDatasource: ProMessagesDatasource,
    public scroll: ScrollDispatcher,
    public element: ElementRef,
  ) {
  }

  ngOnInit() {
    console.log(`${this.TAG} ngOnInit`);

    this.fetchPageSubscription = this.messagesDatasource.fetchPageEmitter.subscribe(() => {
      if (this.shouldInitScroll) {
        this.scrollToBottom();
      }
    });

    this.lastIncomingMessageSubscription = this.messagesDatasource.lastIncomingMessageEmitter.subscribe(value => {
      this.lastIncomingMessageEvent.emit(value);
    });

    this.deBouncer.subscribe(value => {
      console.log(`${this.TAG} simple changes`, value);
      this.shouldInitScroll = true;
      if (!!this.selectedPhoneNumber && !!this.selectedThreadKey) {
        this.messagesDatasource.onFilterDataChange({
          selectedThreadKey: this.selectedThreadKey,
          mainPhoneNumber: this.selectedPhoneNumber,
          searchText: this.searchText,
        });
      } else {
        this.messagesDatasource.loadingSubject.next(false);
        this.messagesDatasource.resetList();
      }
    });

    this.deBouncer?.next(undefined);
  }

  scrollToBottom(): void {
    console.log(`${this.TAG} scrollToBottom 1`);
    setTimeout(() => {
      console.log(`${this.TAG} scrollToBottom 2`);
      this.virtualScroll.scrollToIndex(this.messagesDatasource.length - 1, 'auto');

      setTimeout(() => {
        console.log(`${this.TAG} scrollToBottom 3`);
        this.virtualScroll.scrollToIndex(this.messagesDatasource.length - 1, 'auto');

        if (!this.isBottom()) {
          this.goToBottom();
        }
      }, 500);
    }, 300);
  }

  goToBottom() {
    if (!this.isBottom()) {
      const elm = this.virtualScroll.getElementRef().nativeElement;
      elm.scrollTop = elm.scrollHeight - elm.clientHeight;

      setTimeout(() => {
        this.goToBottom();
      }, 500);
    }
  }

  isBottom(): boolean {
    const elm = this.virtualScroll.getElementRef().nativeElement;
    const delta = elm.scrollHeight - (elm.scrollTop + elm.clientHeight);

    return delta < 1;
  }

  ngOnDestroy() {
    console.log(`${this.TAG} ngOnDestroy`);
    this.fetchPageSubscription?.unsubscribe();
    this.lastIncomingMessageSubscription?.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log(`${this.TAG} changes`, changes);
    if (changes['selectedThreadKey'].currentValue === 'new') {
      this.messagesDatasource.resetList();
    } else {
      this.deBouncer.next(changes);
    }
  }

  ngAfterViewInit(): void {
    console.log(`${this.TAG} ngAfterViewInit`);
    this.scrollContainer.elementScrolled().subscribe(value => {
      this.shouldInitScroll = this.isBottom();
    });
  }
}
